import { NoPermissionState } from "@/components/common/no-permission-state";
import { isForbiddenError } from "@/lib/clinic-grants";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

import {
  PageEyebrowLink,
  PageHeader,
  Input,
  Button,
  Skeleton,
} from "@/components/ui";
import {
  ContainerHeader,
  FormVoucher,
  VoucherDataTable,
} from "@/components/common";
import { useFetchVouchersQuery, usePermission } from "@/hooks";

export function Vouchers() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { checkPermission } = usePermission();

  const [searchParams, setSearchParams] = useSearchParams();
  const page = searchParams.get("page");
  const perPageParam = searchParams.get("per_page");

  const [perPage, setPerPage] = useState<number>(
    perPageParam ? Number(perPageParam) : 10
  );
  const [search, setSearch] = useState<string>("");

  const {
    error: listError,
    data: vouchersData,
    isLoading,
    refetch,
  } = useFetchVouchersQuery({
    page,
    per_page: perPage,
    search,
  });

  const handlePerPageChange = (newPerPage: number) => {
    setPerPage(newPerPage);
    const newSearchParams = new URLSearchParams(searchParams.toString());
    newSearchParams.set("per_page", newPerPage.toString());
    setSearchParams(newSearchParams);
  };

  useEffect(() => {
    if (!checkPermission("voucher", "view vouchers")) {
      navigate("/")
      return
    }
    if (search && search.length >= 1) {
      setTimeout(async () => {
        await refetch();
      }, 1500);
    }
  }, [search, refetch]);

  // SEC-GATES-02: a refusal from the list endpoint is stated, not shown as an empty list.
  if (isForbiddenError(listError)) return <NoPermissionState />;

  return (
    <section className="space-y-7">
      <div className="space-y-5">
        <PageHeader
          eyebrow={
            <PageEyebrowLink to="/financial/account">
              {t("LABEL.financial")}
            </PageEyebrowLink>
          }
          title="Vouchers"
          lede="Códigos de desconto da clínica, com valor e data de validade."
          actions={
            <FormVoucher>
              <Button
                variant="petrol"
                size="lg"
                className="px-5"
                disabled={!checkPermission("voucher", "create vouchers")}
              >
                Criar
              </Button>
            </FormVoucher>
          }
        />
        <ContainerHeader>
          <Input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            type="search"
            aria-label="Pesquisar vouchers"
            placeholder="Pesquisar"
            showError={false}
          />
        </ContainerHeader>
      </div>

      <div className="space-y-2">
        {!vouchersData || isLoading ? (
          <Skeleton className="w-full h-[500px]" />
        ) : (
          <VoucherDataTable
            perPage={perPage}
            handlePerPageChange={handlePerPageChange}
            data={vouchersData}
          />
        )}
      </div>
    </section>
  );
}
